export interface SettingsSlice {
  deniedSettings: string[] | null;
  deniedSettingsExpiry: number | null;
  deniedSettingsError: boolean;
  isLoadingDeniedSettings: boolean;

  setDeniedSettings: (settings: string[], expiry: number) => void;
  clearDeniedSettings: () => void;
  isDeniedSettingsExpired: () => boolean;
  setDeniedSettingsError: (error: boolean) => void;
  setIsLoadingDeniedSettings: (loading: boolean) => void;
}

export const createSettingsSlice = (set: any, get: any): SettingsSlice => ({
  deniedSettings: null,
  deniedSettingsExpiry: null,
  deniedSettingsError: false,
  isLoadingDeniedSettings: false,

  setDeniedSettings: (settings, expiry) =>
    set({
      deniedSettings: settings,
      deniedSettingsExpiry: expiry,
      deniedSettingsError: false,
      isLoadingDeniedSettings: false,
    }),

  clearDeniedSettings: () =>
    set({
      deniedSettings: null,
      deniedSettingsExpiry: null,
      deniedSettingsError: false,
      isLoadingDeniedSettings: false,
    }),

  isDeniedSettingsExpired: () => {
    const state = get();
    if (!state.deniedSettingsExpiry) return true;
    return Date.now() > state.deniedSettingsExpiry;
  },

  setDeniedSettingsError: (error) =>
    set({ deniedSettingsError: error, isLoadingDeniedSettings: false }),

  setIsLoadingDeniedSettings: (loading) => set({ isLoadingDeniedSettings: loading }),
});
